<script>
  import { onMount } from 'svelte';
  import Dialog from '@smui/dialog';
  import Button, { Label, Group as ButtonGroup } from '@smui/button';
  import Cookies from 'js-cookie';
  import 'firebase/auth';
  import * as EmailValidator from 'email-validator';

  import { apiPost } from '../httpCommon';

  export let venueId;

  let dialog;

  function close() {
    Cookies.set('FDNL', 'true', { expires: 0.5 });
    dialog.close();
  }

  function checkCookies() {
    const newsLetterCookie = Cookies.get('FDNL');

    if (!newsLetterCookie) {
      setTimeout(() => {
        dialog.open();
      }, 10000);
    }
  }

  let emailAddressError = '';

  async function submit(e) {
    e.preventDefault();
    const form = new FormData(e.target);
    const email = form.get('email');
    const validEmail = EmailValidator.validate(email);

    if (!email) {
      emailAddressError = 'Please provide an email address';
      return;
    }

    if (!validEmail) {
      emailAddressError = 'Please provide an a vailid email address';
      return;
    }

    try {
      const subscibed = await apiPost('customer/add-menu-subscription', { venue_id: venueId, email });
      Cookies.set('FDNL', 'true', { expires: 365 });
      dialog.close();
    } catch (error) {
      emailAddressError = 'Something went wrong please try again';
    }
  }

  onMount(async () => {
    checkCookies();
  });
</script>

<Dialog bind:this={dialog}>
  <div class="box newsletter">
    <div class="buttons"><button class="close" on:click={close} /></div>
    <h2 class="newsletter__title">Subscribe to our event day menu emails</h2>
    <form class="newsletter__form" on:submit={submit} method="post">
      <input type="email" class="newsletter__input" placeholder="Your email address" name="email" />
      <Button variant="unelevated" class="newsletter__button">
        <Label>Submit</Label>
      </Button>
    </form>
    <div class="newsletter__error-container">
      <span class="newsletter__error">
        {emailAddressError ? emailAddressError : ''}
      </span>
    </div>
    <div class="signup__terms">
      <p class="signup__terms-text">
        By continuing, you indicate that you accept our <a href="https://ff2a6da8-e087-411b-8d56-00d3f8b97ddd.usrfiles.com/ugd/ff2a6d_483567941c2c4dba9e1096a2bad24359.pdf" target="_blank" class="signup__terms-link">Terms</a>.<br />You can also have a
        look at our <a href="https://ff2a6da8-e087-411b-8d56-00d3f8b97ddd.usrfiles.com/ugd/ff2a6d_1b5431434cbf4327941b216d32e8723d.pdf" target="_blank" class="signup__terms-link">Privacy Policy</a>
      </p>
    </div>
  </div>
</Dialog>

<style>
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 19px;
    background: #ffffff;
    border: 3px solid #000000;
    box-sizing: border-box;
    width: 550px;
    overflow-x: hidden;
  }

  @media screen and (max-width: 620px) {
    .box {
      width: auto;
    }
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
  }

  .close {
    width: 25px;
    height: 25px;
    background: url('/close.svg') center/contain no-repeat;
    border: 0px;
    cursor: pointer;
  }

  .newsletter__title {
    margin: 20px 0 40px 0;
    text-align: center;
  }

  @media screen and (max-width: 550px) {
    .newsletter__title {
      font-size: 18px;
    }
  }

  .newsletter__form {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
  }

  @media screen and (max-width: 550px) {
    .newsletter__form {
      flex-direction: column;
    }
  }

  .newsletter__input {
    margin-right: 20px;
    border-radius: 0;
    margin: 0;
    font-size: 16px;
    padding: 8px;
    border: 3px solid rgba(61, 59, 59, 1);
    width: 330px;
  }

  @media screen and (max-width: 550px) {
    .newsletter__input {
      width: 100%;
    }
  }

  .newsletter :global(button.mdc-button) {
    height: 100%;
    margin-bottom: 0;
    border-top: 3px solid #3d3b3b;
    border-bottom: 2px solid #3d3b3b;
    padding-left: 20px;
    padding-right: 20px;
  }

  :global(.mdc-dialog .mdc-dialog__scrim) {
    pointer-events: none;
  }

  @media screen and (max-width: 550px) {
    .newsletter :global(button.mdc-button) {
      margin-top: 10px;
    }
  }
  .signup__terms {
    width: 385px;
    margin: 35px auto 0 auto;
  }
  @media screen and (max-width: 450px) {
    .signup__terms {
      width: 70%;
    }
  }
  @media screen and (max-width: 375px) {
    .signup__terms {
      width: 65%;
    }
  }
  .signup__terms-text {
    margin: 0 auto;
    display: block;
    text-align: center;
    font-size: 12px;
  }

  .signup__terms-link {
    text-decoration: underline;
    font-weight: bold;
  }

  .newsletter__error-container {
    width: 90%;
  }

  .newsletter__error {
    color: rgba(239, 68, 68, 1);
    display: block;
    margin: 5px 0;
    font-family: Manrope;
    font-weight: bold;
    font-size: 14px;
  }
</style>
